import HeroBanner from '../../../components/organisms/heroBannerV2';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';

const ComplexHeroV2Tastic = ({ data, context }) => {
  if (!data) return null;
  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';

  if (!data[`show${locale}`]) return null;

  return <HeroBanner data={data} />;
};

export default tastify({
  translate: true,
  connect: { context: true },
})(ComplexHeroV2Tastic);
